<template>
    <qesg-dash-card-wrapper class="" :noBody="true">
        <slot name="title">
            <b-row class="px-3 py-3 border-bottom border-color-gray-300" align-v="center" no-gutters>
                <b-col cols>
                    <slot name="header-title">
                        <h5 :class="['dash-card-title mr-2 mb-0', titleClass]">{{ title }}</h5>
                    </slot>
                </b-col>
                <b-col cols="auto">
                    <slot name="header-icon">
                        <div class="d-flex justify-content-end">
                            <qesg-dash-card-icon :icon="icon" :variant="iconVariant" :font-scale="iconFontScale" />
                        </div>
                    </slot>
                </b-col>
            </b-row>
        </slot>
        <b-card-body>
            <slot name="default" />
        </b-card-body>
    </qesg-dash-card-wrapper>
</template>

<script>
import qesgDashCardPropsDefault from '@shared_mixins/contractor-dashboard/qesg-dash-card-props-default.js';
import qesgDashCardPropsIcon from '@shared_mixins/contractor-dashboard/qesg-dash-card-props-icon.js';
import QesgDashCardWrapper from '@shared_components/contractor/components/qesg-dash-card-wrapper.vue';
import QesgDashCardIcon from '@shared_components/contractor/components/qesg-dash-card-icon.vue';

export default {
    name: 'qesg-dash-chart-card',
    components: {
        QesgDashCardWrapper,
        QesgDashCardIcon
    },
    mixins: [
        qesgDashCardPropsDefault,
        qesgDashCardPropsIcon
    ],
    props: {
        title: {
            type: String,
            required: false,
            default: (titleProps) => typeof titleProps === 'undefined' ? '' : titleProps
        },
        titleClass: {
            type: [String, Array, Object],
            required: false
        }
    },
    computed: {}
}
</script>

<style>

</style>